/**
 * Shares "which filter popover is currently open" between sibling RmaListFilterControl cards
 * so that opening one closes the others. Scoped to the provider (the filters sidebar) instead
 * of a module-level singleton, so it stays testable and cannot leak across trees.
 */
import React, { createContext, useState } from "react";

export type RmaListFilterPopoverGroupValue = [
    openFilterId: string | null,
    setOpenFilterId: React.Dispatch<React.SetStateAction<string | null>>,
];

export const RmaListFilterPopoverGroupContext =
    createContext<RmaListFilterPopoverGroupValue | null>(null);

interface IProps {
    children: React.ReactNode;
}

export const RmaListFilterPopoverGroup: React.FC<IProps> = ({ children }) => {
    const [openFilterId, setOpenFilterId] = useState<string | null>(null);

    return (
        <RmaListFilterPopoverGroupContext.Provider value={[openFilterId, setOpenFilterId,]}>
            {children}
        </RmaListFilterPopoverGroupContext.Provider>
    );
};
